import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import "./All.css";
import "../style01.css";
import "../style02.css";
import img1 from "../../../assets/images/img1_metuaa_green.svg";
import img2 from "../../../assets/images/img2_metuaa_green.svg";
import img3 from "../../../assets/images/img3_metuaa_green.svg";
import img4 from "../../../assets/images/img4_metuaa_green.svg";
import img5 from "../../../assets/images/img5_metuaa_green.svg";
import app1 from "../../../assets/images/app_1.png";
import app2 from "../../../assets/images/app_2.png";
import f2 from "../../../assets/images/f2.png";
import course_1 from "../../../assets/images/course (1).png"; 
import course_2 from "../../../assets/images/course (2).png";
import course_3 from "../../../assets/images/course (3).png";
import course_4 from "../../../assets/images/course (4).png";
import offer_1 from "../../../assets/images/offer_1.png";
import offer_2 from "../../../assets/images/offer_2.png";
import phone from "../../../assets/images/phone0.png";
import metuaa_green from"../../../assets/images/metuaa_green.png";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import Slide_image_passenger from "../../../assets/images/all-slider/passenger-slide-cameroon.png";
import Slide_image_driver from "../../../assets/images/all-slider/driver-slide-cameroon.png";
import Slide_image_entreprise from "../../../assets/images/all-slider/enterprise-slide-cameroon.png";

// ─── Icônes SVG ───────────────────────────────────────────────────────────────

const IconLanguage = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M15.982 3C8.719 3 4.05 7.7 4.05 14.932c0 3.662 1.16 6.683 3.357 8.82L5.973 29l6.469-2.533c1.13.275 2.35.427 3.57.427 7.263 0 11.932-4.7 11.932-11.932S23.244 3 15.982 3zm0 22.308c-1.251 0-2.624-1.923-3.387-5.036h6.774c-.763 3.113-2.136 5.036-3.387 5.036zm-3.693-6.653a23.424 23.424 0 0 1-.274-3.723c0-1.343.091-2.594.274-3.723h7.385c.184 1.129.275 2.38.275 3.723s-.091 2.594-.275 3.723H12.29zm3.693-14.038c1.251 0 2.624 1.923 3.387 5.036h-6.774c.762-3.113 2.136-5.036 3.387-5.036zm5.31 6.622h4.516c.336 1.068.519 2.32.519 3.723 0 1.404-.183 2.625-.519 3.723h-4.516c.152-1.16.244-2.41.244-3.723 0-1.312-.061-2.563-.244-3.723zm3.875-1.586h-4.15c-.427-1.892-1.068-3.48-1.861-4.639 2.472.61 4.73 2.075 6.011 4.639zM12.808 5.014c-.793 1.16-1.434 2.747-1.861 4.639h-4.15c1.281-2.564 3.54-4.029 6.011-4.639zM6.156 11.24h4.516a28.605 28.605 0 0 0 0 7.446H6.156a13.066 13.066 0 0 1-.52-3.723c0-1.403.184-2.655.52-3.723zm6.164 13.55-3.998 1.556.855-3.113-.366-.335a8.99 8.99 0 0 1-2.015-2.625h4.15c.428 1.892 1.069 3.48 1.862 4.639-.091-.03-.152-.03-.244-.061l-.244-.061zm6.836.122c.793-1.16 1.434-2.747 1.861-4.639h4.15c-1.281 2.533-3.54 3.998-6.011 4.639z" />
  </svg>
);

const IconHamburger = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M29 7.75H3v1.989h26V7.75zm0 7.26H3V17h26v-1.99zm0 7.238H3v1.989h26v-1.99z" />
  </svg>
);

const IconArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

const IconArrowLeft = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m12.843 25.836 1.585-1.608L7.32 17.12H29v-2.256H7.321l7.107-7.13-1.585-1.585L3 15.993l9.843 9.843z" />
  </svg>
);

const IconArrowRightLg = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m19.157 6.15-1.584 1.608 7.106 7.107H3v2.256h21.679l-7.106 7.13 1.584 1.585L29 15.993 19.157 6.15z" />
  </svg>
);

const IconChevronDown = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M7.988 12.11 1 5.098 2.208 3.89l5.78 5.78 5.78-5.78L15 5.098 7.988 12.11z" />
  </svg>
);

const IconPickup = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M4.8 25.6h5.9V29h1.7v-5.1H4.8v1.7zM17.5 8C18.9 8 20 6.9 20 5.5S18.9 3 17.5 3 15 4.1 15 5.5 16.1 8 17.5 8z" />
    <path d="M25.3 5.4s-.6 1.2-2.5 2.6c-1.1.8-2.6 1.3-4 1.3h-2.7c-2.2 0-4.2 1.2-5.3 3.1-1.4 2.6-1.9 4.3-1.9 4.4l2.1.5s.4-1.6 1.7-3.9c.4-.7 1-1.3 1.8-1.6V29h2.1v-9.8h1.9V29h2.1V11.2c1.2-.3 2.4-.7 3.4-1.5 2.4-1.7 3.1-3.2 3.2-3.4l-1.9-.9z" />
  </svg>
);

const IconCalendarScheduled = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M24.119 5.69V3h-1.594v2.69H9.475V3H7.881v2.69H6.287C4.494 5.69 3 7.084 3 8.977V29h22.713C27.506 29 29 27.506 29 25.713V5.69h-4.881zM6.287 7.284h1.594v2.49h1.594v-2.49h13.05v2.49h1.594v-2.49h3.287v4.682H4.594V8.977c0-.996.797-1.693 1.693-1.693zm19.426 20.122H4.593V13.46h22.813v12.153c0 .996-.797 1.793-1.693 1.793z" />
    <path d="M24.119 20.732h-4.383v4.383h4.383v-4.383z" />
  </svg>
);

const IconPromos = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m9.431 19.428-.7-1.259-.7 1.26a8.737 8.737 0 0 1-3.442 3.47l-1.259.671 1.26.7a8.807 8.807 0 0 1 3.47 3.47l.7 1.26.7-1.26a8.807 8.807 0 0 1 3.47-3.47l1.259-.7-1.26-.7a8.631 8.631 0 0 1-3.498-3.442zm-.7 6.465A9.922 9.922 0 0 0 6.438 23.6a9.923 9.923 0 0 0 2.295-2.295 9.926 9.926 0 0 0 2.294 2.295 9.924 9.924 0 0 0-2.294 2.294zm.672-14.805a9.978 9.978 0 0 1 4.03-4.03A10.221 10.221 0 0 1 9.403 3c-.923 1.707-2.35 3.107-4.058 4.058a10.22 10.22 0 0 1 4.058 4.03zm18.22 3.667a19.02 19.02 0 0 1-7.585-7.585l-.7-1.26-.7 1.26a18.674 18.674 0 0 1-7.584 7.585l-1.259.7 1.26.699a19.019 19.019 0 0 1 7.584 7.584l.7 1.26.7-1.26a18.675 18.675 0 0 1 7.584-7.584l1.26-.7-1.26-.7zm-8.284 7.052a20.54 20.54 0 0 0-6.353-6.353 20.541 20.541 0 0 0 6.353-6.353 20.544 20.544 0 0 0 6.353 6.353 20.846 20.846 0 0 0-6.353 6.353z" />
  </svg>
);

const IconRocket = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M28.926 3.087S28.14 3 26.943 3c-2.31 0-6.144.327-8.606 2.179a44.097 44.097 0 0 0-6.165 6.732l-.109.152c-.043.044-.065.087-.109.13H9.471a4.119 4.119 0 0 0-2.963 1.243L3 16.965l5.86 1.09 5.033 5.054 1.09 5.882 3.485-3.551a4.209 4.209 0 0 0 1.198-2.941v-2.375a46.317 46.317 0 0 0 7.081-6.47c2.876-3.704 2.179-10.567 2.179-10.567zM6.268 15.963l1.372-1.394a2.627 2.627 0 0 1 1.83-.763h1.373L8.97 16.464l-2.701-.501zm11.808 6.58c0 .675-.261 1.328-.74 1.808l-1.33 1.35-.5-2.636 2.57-1.808v1.285zm7.43-9.892a44.837 44.837 0 0 1-6.34 5.86l-4.489 3.16-4.335-4.38 3.006-4.27a42.042 42.042 0 0 1 6.013-6.579c2.114-1.59 5.665-1.83 7.582-1.83h.458c.043 2.244-.284 5.926-1.896 8.04z" />
    <path d="M23 8.926a2.19 2.19 0 0 0-1.133-.588 2.26 2.26 0 0 0-1.264.13 2.258 2.258 0 0 0-1.35 2.048c0 .436.13.872.37 1.22.24.37.588.654.98.828a2.1 2.1 0 0 0 1.264.13A2.19 2.19 0 0 0 23 12.108l-.087.109c.24-.196.414-.458.566-.741.13-.283.196-.588.218-.893 0-.305-.044-.632-.174-.915A2.866 2.866 0 0 0 23 8.926zM9.427 25.483a9.863 9.863 0 0 1-3.18.37 9.373 9.373 0 0 1 .544-3.725 6.359 6.359 0 0 1 1.481-2.287l-1.83-.349a7.56 7.56 0 0 0-1.176 2.07 11 11 0 0 0-.567 5.098l.066.61.61.087c.457.065.936.087 1.394.087 1.024 0 2.07-.152 3.072-.435a7.986 7.986 0 0 0 2.767-1.438l-.349-1.852c-.697.828-1.7 1.438-2.832 1.764z" />
  </svg>
);

const IconCoupon = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="m28.33 11.98-3.446-2.45-1.27-4.05-4.233.06L15.995 3 12.61 5.54l-4.232-.06-1.27 4.05-3.477 2.45L4.99 16l-1.36 4.02 3.477 2.45 1.27 4.05 4.232-.06L15.995 29l3.386-2.54 4.233.06 1.27-4.05 3.476-2.45L27 16l1.33-4.02zm-1.905 7.406-2.932 2.056-1.058 3.416-3.598-.03-2.872 2.146-2.872-2.146-3.598.03-1.058-3.416-2.933-2.056L6.654 16l-1.15-3.386 2.933-2.056 1.058-3.416 3.598.03 2.902-2.177 2.872 2.147 3.598-.03 1.058 3.416 2.933 2.056-1.15 3.386 1.12 3.416z" />
    <path d="M19.656 10.884 10.89 19.65l1.41 1.411 8.766-8.765-1.411-1.41zm-6.684 3.696c.877 0 1.602-.726 1.602-1.603s-.725-1.603-1.602-1.603c-.877 0-1.602.726-1.602 1.603s.695 1.602 1.602 1.602zm6.046 2.81c-.876 0-1.602.726-1.602 1.603s.726 1.602 1.602 1.602c.877 0 1.603-.725 1.603-1.602 0-.877-.726-1.602-1.603-1.602z" />
  </svg>
);

const IconGrinningFace = () => (
  <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13S23.2 3 16 3zm0 24.4C9.7 27.4 4.6 22.3 4.6 16 4.6 9.7 9.7 4.6 16 4.6c6.3 0 11.4 5.1 11.4 11.4 0 6.3-5.1 11.4-11.4 11.4z" />
    <path d="M10.4 18.7c.6 2.6 2.9 4.4 5.6 4.4 2.7 0 4.9-1.8 5.6-4.4l.2-1H10.2l.2 1zm10.8-6.9c-1.3 0-2.4 1.2-2.4 2.7h1.6c0-.6.4-1.1.8-1.1s.8.5.8 1.1h1.6c0-1.5-1.1-2.7-2.4-2.7zm-10.4 1.6c.4 0 .8.5.8 1.1h1.6c0-1.5-1.1-2.7-2.4-2.7-1.3 0-2.4 1.2-2.4 2.7H10c0-.6.4-1.1.8-1.1z" />
  </svg>
);

const IconTwitter = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M5.403 13.376c5.283 0 8.172-4.377 8.172-8.173 0-.124 0-.248-.008-.371A5.844 5.844 0 0 0 15 3.345a5.732 5.732 0 0 1-1.65.452 2.882 2.882 0 0 0 1.263-1.589c-.564.335-1.18.57-1.824.697a2.875 2.875 0 0 0-4.895 2.62 8.155 8.155 0 0 1-5.92-3 2.874 2.874 0 0 0 .89 3.833 2.85 2.85 0 0 1-1.304-.36v.037c0 1.368.964 2.545 2.304 2.816a2.868 2.868 0 0 1-1.297.05 2.876 2.876 0 0 0 2.684 1.994A5.763 5.763 0 0 1 1 12.085a8.132 8.132 0 0 0 4.403 1.289" />
  </svg>
);

const IconFacebook = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M15 8a7 7 0 1 0-8.094 6.915v-4.892H5.13V8h1.777V6.458c0-1.755 1.045-2.724 2.644-2.724.766 0 1.567.137 1.567.137v1.723h-.883c-.87 0-1.14.54-1.14 1.093V8h1.941l-.31 2.023H9.094v4.892A7.002 7.002 0 0 0 15 8z" clipRule="evenodd" fillRule="evenodd" />
  </svg>
);

const IconInstagram = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M7.998 4.918a3.08 3.08 0 1 0 0 6.16 3.08 3.08 0 0 0 0-6.16zm0 5.08a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" clipRule="evenodd" fillRule="evenodd" />
    <path d="M11.2 5.516a.72.72 0 1 0 0-1.44.72.72 0 0 0 0 1.44z" />
    <path d="M7.998 2c-1.629 0-1.833.007-2.473.036-.638.03-1.074.13-1.456.279a2.94 2.94 0 0 0-1.062.692 2.94 2.94 0 0 0-.692 1.062c-.148.382-.25.818-.279 1.456-.03.64-.036.844-.036 2.473 0 1.63.007 1.833.036 2.473.03.639.13 1.075.279 1.456.153.395.358.729.692 1.063.333.333.668.538 1.062.691.382.149.818.25 1.456.28.64.028.844.035 2.473.035 1.63 0 1.833-.007 2.473-.036.639-.029 1.075-.13 1.456-.279a2.939 2.939 0 0 0 1.063-.691c.333-.334.538-.668.691-1.063.149-.381.25-.817.28-1.456.028-.64.035-.844.035-2.473s-.007-1.833-.036-2.473c-.029-.638-.13-1.074-.279-1.456a2.939 2.939 0 0 0-.691-1.062 2.94 2.94 0 0 0-1.063-.692c-.381-.148-.817-.25-1.456-.279C9.831 2.006 9.627 2 7.998 2zm0 1.08c1.602 0 1.791.007 2.424.036.585.026.902.124 1.114.206.28.11.48.239.69.449.21.21.34.41.448.69.082.211.18.529.207 1.113.028.633.034.823.034 2.424 0 1.602-.006 1.791-.034 2.424-.027.585-.125.902-.207 1.114-.109.28-.239.48-.449.69-.21.21-.41.34-.69.448-.21.082-.528.18-1.113.207-.633.028-.822.034-2.424.034-1.602 0-1.791-.006-2.424-.034-.584-.027-.902-.125-1.113-.207a1.858 1.858 0 0 1-.69-.449c-.21-.21-.34-.41-.449-.69-.082-.21-.18-.528-.206-1.113-.03-.633-.035-.822-.035-2.424 0-1.601.006-1.791.035-2.424.026-.584.124-.902.206-1.113.11-.28.239-.48.449-.69.21-.21.41-.34.69-.449.211-.082.529-.18 1.113-.206.633-.03.823-.035 2.424-.035z" clipRule="evenodd" fillRule="evenodd" />
  </svg>
);

// Icônes carrousel
const IconDollar = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M8 1C4.155 1 1 4.1 1 8s3.155 7 7 7 7-3.1 7-7c-.099-3.9-3.254-7-7-7zm2.86 9.1c-.297.7-.987 1.4-2.268 1.6v.9H7.31v-.9c-1.085-.2-1.775-.6-2.07-1l.985-.8c.198.2.79.6 1.972.6.888 0 1.38-.4 1.48-.8.098-.3 0-.5-.1-.7-.394-.3-1.084-.4-1.774-.5-.888-.1-1.676-.2-2.268-.7-.591-.5-.69-1.4-.394-2.1.296-.9 1.183-1.4 2.267-1.5v-.9h1.184v.9c1.084.2 1.676.6 2.07 1l-.986.8c-.296-.2-.789-.6-1.972-.6-.789 0-1.281.3-1.479.7-.098.3-.098.6.099.7.296.3.986.3 1.577.4.888.1 1.775.2 2.465.8.592.6.789 1.4.493 2.1z" />
  </svg>
);

const IconValet = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M7.577 4.308c1.271.293 2.347-.783 2.054-2.054a1.624 1.624 0 0 0-1.206-1.206A1.704 1.704 0 0 0 6.37 3.1c.13.587.62 1.076 1.206 1.207zm2.445 1.336c-.424-.13-1.434-.26-2.021-.26-.62 0-1.597.162-2.054.293-.945.26-1.662 1.075-2.347 4.27h1.271c.49-2.184.946-2.803 1.24-3.032L6.663 15h2.478l.75-8.117c.293.163.75.717 1.271 3.032h1.239c-.685-3.163-1.402-3.978-2.38-4.27z" />
  </svg>
);

const IconLightning = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M12.4 6.7H8.9V1L3.6 9.3h3.5V15l5.3-8.3z" />
  </svg>
);

const IconCar = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M14.95 9.686c.056-.693.076-1.4 0-1.808-.207-1.013-.606-1.398-1.03-1.804l-.3-.297h1.04v-.996h-1.55l-.58-1.61a2.27 2.27 0 0 0-1.938-1.333c-3.195-.192-5.13 0-5.218 0a2.35 2.35 0 0 0-1.927 1.368l-.564 1.577H1.33v.996h1.037l-.337.332c-.418.39-.848.789-.995 1.797-.052.63-.046 1.263.02 1.892v.022c.042.544.102 1.078.157 1.49l.22 1.995a.988.988 0 0 0 .987.946h.7a.99.99 0 0 0 .989-.99v-.63c.988.034 2.286.064 3.879.064s2.892-.03 3.879-.065v.63a.991.991 0 0 0 .99.99h.699a.981.981 0 0 0 .986-.909l.243-2.16c.052-.376.12-.92.165-1.486l.002-.01zM5.854 8.73a.83.83 0 0 1-.825.797H3.742a.787.787 0 0 1-.788-.797.815.815 0 0 1 .788-.789h1.325a.788.788 0 0 1 .786.789zm7.17 0a.84.84 0 0 1-.837.797h-1.281a.787.787 0 0 1-.788-.797.815.815 0 0 1 .788-.789h1.325a.787.787 0 0 1 .792.789zM4.356 3.583a1.354 1.354 0 0 1 1.103-.752c.018 0 1.944-.184 5.052 0a1.26 1.26 0 0 1 1.076.714l.788 2.183a37.75 37.75 0 0 1-4.396.197 37.602 37.602 0 0 1-4.435-.201l.812-2.14z" />
  </svg>
);

const IconStar = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M14.556 7.543a1.08 1.08 0 0 0-.632-1.951h-2.961a1.077 1.077 0 0 1-1.024-.743l-.914-2.815a1.08 1.08 0 0 0-2.05 0L6.06 4.85a1.082 1.082 0 0 1-1.027.743H2.076a1.08 1.08 0 0 0-.632 1.951l2.393 1.739a1.076 1.076 0 0 1 .391 1.203l-.913 2.816a1.08 1.08 0 0 0 1.656 1.206l2.393-1.74a1.074 1.074 0 0 1 1.267 0l2.393 1.74A1.079 1.079 0 0 0 12.68 13.3l-.914-2.816a1.076 1.076 0 0 1 .392-1.203l2.398-1.739z" />
  </svg>
);

const IconFamily = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M4.301 5.473c.948 0 1.712-.764 1.712-1.711 0-.948-.764-1.712-1.712-1.712a1.71 1.71 0 0 0-1.712 1.712 1.71 1.71 0 0 0 1.712 1.711zm7.428 0a1.71 1.71 0 0 0 1.712-1.711 1.71 1.71 0 0 0-1.712-1.712c-.948 0-1.712.764-1.712 1.712 0 .947.764 1.711 1.712 1.711zM8 9.294c-1.865 0-2.63.795-2.63 2.69v1.956h5.228v-1.956c0-1.895-.825-2.69-2.598-2.69zm0-1.07c.856 0 1.528-.672 1.528-1.528S8.856 5.168 8 5.168s-1.53.672-1.53 1.528S7.144 8.224 8 8.224zM5.463 6.696v-.092c-.337-.091-.734-.122-1.162-.122C1.947 6.482 1 7.491 1 9.875v2.904h3.118v-.795c0-2.109.886-3.148 1.987-3.607a2.495 2.495 0 0 1-.642-1.68zm6.266-.214c-.459 0-.856.061-1.223.122v.092a2.51 2.51 0 0 1-.672 1.712c1.283.55 1.986 1.773 1.986 3.576v.795H15V9.875c.03-2.384-1.01-3.393-3.271-3.393z" />
  </svg>
);

const IconPrivacyChoice = () => (
  <svg height="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 14">
    <g fillRule="evenodd" clipRule="evenodd" fill="#fff">
      <path d="M7.4 12.8h6.8l3.1-11.6H7.4C4.2 1.2 1.6 3.8 1.6 7s2.6 5.8 5.8 5.8z" />
    </g>
    <g fillRule="evenodd" clipRule="evenodd" fill="#06f">
      <path d="M22.6 0H7.4c-3.9 0-7 3.1-7 7s3.1 7 7 7h15.2c3.9 0 7-3.1 7-7s-3.2-7-7-7zm-21 7c0-3.2 2.6-5.8 5.8-5.8h9.9l-3.1 11.6H7.4c-3.2 0-5.8-2.6-5.8-5.8z" />
    </g>
    <g fill="#fff">
      <path d="M24.6 4c.2.2.2.6 0 .8L22.5 7l2.2 2.2c.2.2.2.6 0 .8-.2.2-.6.2-.8 0l-2.2-2.2-2.2 2.2c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8L20.8 7l-2.2-2.2c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l2.2 2.2L23.8 4c.2-.2.6-.2.8 0z" />
    </g>
    <g fill="#06f">
      <path d="M12.7 4.1c.2.2.3.6.1.8L8.6 9.8c-.1.1-.2.2-.3.2-.2.1-.5.1-.7-.1L5.4 7.7c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0L8 8.6l3.8-4.5c.2-.2.6-.2.9 0z" />
    </g>
  </svg>
);

// ─── Diapositives du Hero ──────────────────────────────────────────────────────

const heroSlides = [
  {
    webp: Slide_image_passenger,
    src: Slide_image_passenger,
    alt: "Smiling older woman with a yellow scarf leans into a car, holding a tote bag, while a man looks back at her.",
    title1Id: "home.hero.slide1.title1",
    title2Id: "home.hero.slide1.title2",
    descriptionId: "home.hero.slide1.description",
    ctaHref: "/signup-passenger",
  },
  {
    webp: Slide_image_driver,
    src: Slide_image_driver,
    alt: "Smiling man in a coral shirt drives a car, touching a phone mounted on the dashboard, with a Metua'a sticker visible.",
    title1Id: "home.hero.slide2.title1",
    title2Id: "home.hero.slide2.title2",
    descriptionId: "home.hero.slide2.description",
    ctaHref: "/signup-driver",
  },
  {
    webp: Slide_image_entreprise,
    src: Slide_image_entreprise,
    alt: "Business team reviewing transportation plans, representing Metua'a's enterprise ride solutions.",
    title1Id: "home.hero.slide3.title1",
    title2Id: "home.hero.slide3.title2",
    descriptionId: "home.hero.slide3.description",
    ctaHref: "/signup-entreprise",
  },
];

const heroTransitionTypes = ["fade", "slide-left", "slide-right", "square"];

// ─── Données carrousel ─────────────────────────────────────────────────────────

const carouselCards = [
  {
    labelId: "home.carousel.card1.label",
    titleId: "home.carousel.card1.title",
    img: img1,
    descIcons: [<IconDollar />, <IconValet />],
    descTextIds: ["home.carousel.card1.desc1", "home.carousel.card1.desc2"],
  },
  {
    labelId: "home.carousel.card2.label",
    titleId: "home.carousel.card2.title",
    img: img2,
    descIcons: [<IconLightning />, <IconValet />],
    descTextIds: ["home.carousel.card2.desc1", "home.carousel.card2.desc2"],
  },
  {
    labelId: "home.carousel.card3.label",
    titleId: "home.carousel.card3.title",
    img: img3,
    descIcons: [<IconLightning />, <IconValet />],
    descTextIds: ["home.carousel.card3.desc1", "home.carousel.card3.desc2"],
  },
  {
    labelId: "home.carousel.card4.label",
    titleId: "home.carousel.card4.title",
    img: img4,
    descIcons: [<IconCar />, <IconStar />],
    descTextIds: ["home.carousel.card4.desc1", "home.carousel.card4.desc2"],
  },
  {
    labelId: "home.carousel.card5.label",
    titleId: "home.carousel.card5.title",
    img: img5,
    descIcons: [<IconCar />, <IconFamily />],
    descTextIds: ["home.carousel.card5.desc1", "home.carousel.card5.desc2"],
  },
];

// ─── Données footer ────────────────────────────────────────────────────────────

const footerDriverLinks = [
  { href: "https://www.lyft.com/drive-with-lyft", text: "Devenir chauffeur" },
  { href: "https://www.lyft.com/driver/new-driver-guide", text: "Guide du nouveau chauffeur" },
  { href: "/driver/pay", text: "Recettes" },
  { href: "/driver/cities", text: "Villes" },
  { href: "https://www.lyft.com/click/dax-help-center", text: "Aide" },
  { href: "/driver/safety", text: "Sécurité" },
  { href: "/driver-application-requirements", text: "Exigences de candidature" },
  { href: "/expressdrive", text: "Conduite Express" },
  { href: "/driver/bonus", text: "Prime" },
  { href: "/driver/rewards", text: "Récompenses Metua'a" },
  { href: "/driver/insurance", text: "Assurance" },
  { href: "/black-car-fleet", text: "Flottes de voitures Noires" },
  { href: "/hub", text: "Blogue du chauffeur" },
  { href: "/driver/beta", text: "Programme bêta" },
];

const footerRiderLinks = [
  { href: "/rider", text: "Inscrivez-vous" },
  { href: "https://www.lyft.com/memberships/lyft-pink-all-access-annual/offer-details", text: "Metua'a Pink" },
  { href: "/rider/cities", text: "Villes" },
  { href: "https://www.lyft.com/click/pax-help-center", text: "Aide" },
  { href: "/rider/safety", text: "Sécurité" },
  { href: "/rider/business", text: "Profil professionnel" },
  { href: "/rider/rewards", text: "Récompenses" },
  { href: "/events", text: "Événements" },
  { href: "/rider/airports", text: "Aéroports" },
  { href: "/gift", text: "Cartes-cadeaux" },
  { href: "/donate", text: "Faire un don" },
];

const footerLyftLinks = [
  { href: "/careers", text: "Carrières" },
  { href: "/lyftup/programs", text: "Metua'aUp" },
  { href: "/business", text: "Entreprises" },
  { href: "/healthcare", text: "Soins de santé" },
  { href: "/bikes", text: "Vélos" },
  { href: "/scooters", text: "Trottinettes" },
  { href: "/autonome", text: "Autonome" },
  { href: "https://ads.lyft.com", text: "Publicités Metua'a" },
  { href: "/lieux-et-evenements", text: "Partenariats avec l'équipe Venue" },
  { href: "/developers", text: "Développeurs" },
  { href: "/blog", text: "Blogue Metua'a" },
  { href: "/press", text: "Médias" },
  { href: "https://investor.lyft.com", text: "Relations avec les investisseurs" },
];

// ─── Sous-composants ───────────────────────────────────────────────────────────

function CarouselCard({ card, index }) {
  const intl = useIntl();

  return (
    <div
      aria-label={intl.formatMessage({ id: card.labelId })}
      role="tabpanel"
      className="sc-1b0948ad-3 hBYsBS"
      style={{ flex: "0 0 auto", marginRight: "8px" }}
    >
      <div className="sc-imWYAI cbwVrP">
        <button
          aria-expanded="false"
          data-testid="card"
          className="sc-17b8964b-0 iRYMxn"
          style={{ width: "212px", minHeight: "256px" }}
        >
          <div className="sc-17b8964b-4 eNpPVj">
            <span data-testid="text" className="sc-bmzYkS jHVFAY">
              {intl.formatMessage({ id: card.titleId })}
            </span>
          </div>
          <div data-testid="core-ui-spacer" className="sc-gsFSXq gnHzMj" />
          <picture data-testid="img-container">
            <img
              src={card.img}
              alt=""
              data-testid="image"
              width={index === 2 || index === 4 ? 72 : 73}
              height={51}
              className="sc-cb728b07-0 bLpAQa sc-17b8964b-1 cALoZb"
            />
          </picture>
          <div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" />
          <div className="sc-f7dba9ea-2 cuxMbl">
            <div className="sc-f7dba9ea-1 iTmZYN">
              <p data-testid="core-ui-text" className="sc-bmzYkS iKCksV sc-6e64fb35-0">
                <span className="sc-f7dba9ea-0 bizXex">
                  <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                    {card.descIcons[0]}
                  </span>
                </span>
                {intl.formatMessage({ id: card.descTextIds[0] })}
                <br />
                <span className="sc-f7dba9ea-0 bizXex">
                  <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                    {card.descIcons[1]}
                  </span>
                </span>
                {intl.formatMessage({ id: card.descTextIds[1] })}
              </p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

function FooterColumn({ title, links }) {
  return (
    <div className="sc-dOvA-dm gASdYH">
      <div className="sc-eSfNbN gdATaP">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">{title}</h2>
      </div>
      <button className="sc-bXWnss dAzuYD core-ui-focus">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">{title}</h2>
        <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
          <IconChevronDown />
        </span>
      </button>
      <ul className="sc-fLvQuD kmaTJn">
        {links.map((link, i) => (
          <li key={i} className="sc-cRmqLi fvtyuu">
            <a href={link.href} className="sc-dUWDJJ gtZVmu">
              <span data-testid="core-ui-text" className="sc-bmzYkS kfdjbm">
                {link.text}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <div className="sc-aNeao eSwNsk">
        <div data-testid="core-ui-horizontal-divider" className="sc-iMWBiJ iTMXWV" />
      </div>
    </div>
  );
}

// ─── Composant principal ───────────────────────────────────────────────────────

export default function All() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const [carouselOffset, setCarouselOffset] = useState(0);
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroPrevIndex, setHeroPrevIndex] = useState(0);
  const [heroTransition, setHeroTransition] = useState("fade");
  const [isHeroPaused, setIsHeroPaused] = useState(false);

  const goToHeroSlide = (updater) => {
    const type = heroTransitionTypes[Math.floor(Math.random() * heroTransitionTypes.length)];
    setHeroTransition(type);
    setHeroIndex(updater);
  };

  // Défilement automatique du Hero, en pause tant que la souris est dessus
  useEffect(() => {
    if (isHeroPaused) return;
    const id = setInterval(() => {
      goToHeroSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(id);
  }, [isHeroPaused]);

  // La diapositive précédente reste affichée sous la nouvelle le temps de l'animation
  useEffect(() => {
    if (heroPrevIndex === heroIndex) return;
    const id = setTimeout(() => setHeroPrevIndex(heroIndex), 900);
    return () => clearTimeout(id);
  }, [heroIndex, heroPrevIndex]);

  // Injecter les feuilles de style Metua'a dans le <head>

  const cardWidth = 228; // largeur carte + gap
  const maxOffset = (carouselCards.length - 1) * cardWidth;

  return (
    <div id="__next" style={{ zoom: 0.82 }}>
      <div className="sc-19804fb5-0 fKeZVt">
        <span data-testid="core-ui-theme-provider" className="sc-dGCmGc kFXgow">

          {/* ── Skip link ── */}
          <div className="sc-a297abbd-0 hLwNen">
            <span data-testid="core-ui-theme-provider" className="sc-dGCmGc jYRudL sc-63eb72f4-0 dWpSLp">
              <span data-testid="core-ui-button-wrapper" className="sc-eBMEME eHLGuU">
                <button
                  data-testid="core-ui-button"
                  type="button"
                  aria-disabled="false"
                  style={{ "--padding": "16px", "--min-height": "32px", "--min-width": "100px" }}
                  className="sc-dCFHLb sc-tagGq sc-esYiGF dfkCaR krlRAc HOcMb"
                >
                  <span className="sc-gmPhUn kESbtj">
                    <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                      <span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">
                        {t("home.skipToMain")}
                      </span>
                    </span>
                  </span>
                </button>
              </span>
            </span>
          </div>

          <span data-testid="core-ui-theme-provider" className="sc-dGCmGc cukWQg">

            {/* ══════════════════ HEADER ══════════════════ */}

            <Header />

            {/* ══════════════════ MAIN ══════════════════ */}
            <main tabIndex={-1} className="sc-7538ab81-0 bAfcgL">

              {/* ── Hero plein écran avec texte superposé ── */}
              <section
                data-testid="hero-form-container"
                data-tracking-label="Homepage > Brand Redesign Jun 2025 > Hero"
                data-tracking-action="view"
                data-tracking-category="Hero"
                onMouseEnter={() => setIsHeroPaused(true)}
                onMouseLeave={() => setIsHeroPaused(false)}
                style={{
                  position: "relative",
                  width: "100%",
                  minHeight: "480px",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {/* Image de fond plein écran : calque stable + calque animé entrant */}
                <picture
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <source type="image/webp" srcSet={heroSlides[heroPrevIndex].webp} />
                  <img
                    src={heroSlides[heroPrevIndex].src}
                    alt={heroSlides[heroPrevIndex].alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center center",
                      display: "block",
                    }}
                  />
                </picture>

                {heroIndex !== heroPrevIndex && (
                  <picture
                    key={heroIndex}
                    className={`hero-slide-anim hero-anim-${heroTransition}`}
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <source type="image/webp" srcSet={heroSlides[heroIndex].webp} />
                    <img
                      src={heroSlides[heroIndex].src}
                      alt={heroSlides[heroIndex].alt}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center center",
                        display: "block",
                      }}
                    />
                  </picture>
                )}

                {/* Overlay sombre dégradé pour lisibilité du texte */}
                <div
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(to right, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.35) 55%, rgba(0,0,0,0.05) 100%)",
                  }}
                />

                {/* Contenu texte superposé */}
                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    width: "100%",
                    maxWidth: 1280,
                    margin: "0 auto",
                    padding: "56px 40px 96px",
                  }}
                >
                  <div
                    key={heroIndex}
                    className={`hero-slide-anim hero-anim-${heroTransition}`}
                    style={{ maxWidth: 480 }}
                  >
                    {/* Titre : première ligne blanche + seconde ligne verte METUA'A */}
                    <h1
                      data-testid="core-ui-text"
                      style={{
                        fontFamily: "'RebelSansDisplay', -apple-system, sans-serif",
                        fontWeight: 700,
                        fontSize: "clamp(2.4rem, 5vw, 3.8rem)",
                        lineHeight: 1.1,
                        margin: "0 0 16px 0",
                        color: "#ffffff",
                      }}
                    >
                      {t(heroSlides[heroIndex].title1Id)}{" "}
                      <span style={{ color: "#0c6f3f" }}>{t(heroSlides[heroIndex].title2Id)}</span>
                    </h1>

                    <p
                      data-testid="core-ui-text"
                      style={{
                        fontSize: "0.95rem",
                        lineHeight: 1.6,
                        color: "#ffffff",
                        margin: "0 0 28px 0",
                        fontWeight: 400,
                      }}
                    >
                      {t(heroSlides[heroIndex].descriptionId)}
                    </p>

                    <a
                      data-testid="core-ui-button"
                      data-tracking-category="Hero Link Button"
                      data-tracking-action="click"
                      data-tracking-label="Homepage > Brand Redesign Jun 2025 > Hero"
                      data-tracking-value={t("home.hero.cta")}
                      aria-disabled="false"
                      href={heroSlides[heroIndex].ctaHref}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#0c6f3f",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: "48px",
                        padding: "14px 28px",
                        fontSize: "1rem",
                        fontWeight: 600,
                        textDecoration: "none",
                        cursor: "pointer",
                        transition: "background-color 200ms",
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#095c34"}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#0c6f3f"}
                    >
                      {t("home.hero.cta")}
                    </a>
                  </div>
                </div>

                {/* Navigation flèches superposées sur le Hero */}
                <div
                  style={{
                    position: "absolute",
                    right: 40,
                    bottom: 32,
                    zIndex: 3,
                    display: "flex",
                    gap: "8px",
                  }}
                >
                  <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                    <button
                      data-testid="core-ui-icon-button"
                      aria-label={t("home.hero.prev")}
                      type="button"
                      aria-disabled={false}
                      onClick={() => goToHeroSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
                      style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px", "--height": "48px", "--width": "48px" }}
                      className="sc-dCFHLb sc-hknOHE kVYxaI"
                    >
                      <span className="sc-gmPhUn kESbtj">
                        <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                          <IconArrowLeft />
                        </span>
                      </span>
                    </button>
                  </span>
                  <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                    <button
                      data-testid="core-ui-circular-button"
                      aria-label={t("home.hero.next")}
                      type="button"
                      aria-disabled={false}
                      onClick={() => goToHeroSlide((prev) => (prev + 1) % heroSlides.length)}
                      style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px", "--height": "48px", "--width": "48px" }}
                      className="sc-dCFHLb sc-fhzFiK kVYxaI jPFbmJ"
                    >
                      <span className="sc-gmPhUn kESbtj">
                        <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                          <IconArrowRightLg />
                        </span>
                      </span>
                    </button>
                  </span>
                </div>
              </section>

              {/* ── Module Chauffeur ── */}
              <section
                className="sc-cd975d71-0 cNVcPq sc-4d039203-0 bSFrFT"
                data-tracking-label="Homepage > Brand Redesign Jun 2025 > Driver Module"
                data-tracking-action="view"
                data-tracking-category="TextImageModule"
              >
                <div className="sc-eNSrOW kusvag">
                  <div data-testid="core-ui-layout-grid" className="sc-satoz iOqNLX">
                    <div className="sc-cd975d71-0 hWnSlW">
                      <div className="sc-d6f13c2d-0 gLYlJz">
                        <div aria-hidden="true" className="sc-d6f13c2d-1 lkohZJ" />
                        <div className="sc-d6f13c2d-2 cGKmAe">
                          <div data-testid="core-ui-layout-grid" className="sc-satoz iYojpr">

                          <div
                            data-testid="core-ui-layout-container"
                            className="sc-isRoRg eaTAFl"
                          >

                            {/* Conteneur principal : image à gauche, texte à droite */}

                              {/* Image + carte Client/Rating superposée */}
                              <div
                            style={{
                              maxWidth: "520px",
                              margin: "0 auto",
                              position: "relative",
                            }}
                          >
                                <div className="sc-1f8fcd9f-2 dhVyTx" style={{ position: "relative" }}>
                                  <picture data-testid="img-container">
                                    <img
                                      src={f2}
                                      alt="image"
                                      width={100}
                                      height={672}
                                      loading="lazy"
                                      className="sc-cb728b07-0 bLpAQa sc-3cb8a2ed-0 hZVhLw"
                                      style={{ width: "100%", height: "auto", display: "block", marginLeft:"130px" }}
                                    />
                                  </picture>

                                  {/* Carte flottante Client / Rating */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "55px",
                                      left: "50%",
                                      zIndex: 2,
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        position: "relative",
                                        padding: "16px",
                                        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                        display: "flex",
                                        gap: "28px",
                                      }}
                                    >
                                      {/* Bloc Client */}
                                      <div>
                                        <h6
                                          style={{
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            color: "#1a1a1a",
                                            margin: "0 0 8px 0",
                                          }}
                                        >
                                          Client
                                        </h6>
                                        <ul
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            listStyle: "none",
                                            margin: 0,
                                            padding: 0,
                                          }}
                                        >
                                          {[
                                            "https://randomuser.me/api/portraits/women/65.jpg",
                                            "https://randomuser.me/api/portraits/men/32.jpg",
                                            "https://randomuser.me/api/portraits/women/44.jpg",
                                          ].map((src, i) => (
                                            <li
                                              key={i}
                                              style={{
                                                width: "28px",
                                                height: "28px",
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                border: "2px solid #fff",
                                                marginLeft: i === 0 ? 0 : "-10px",
                                                boxShadow: "0 0 0 1px #eee",
                                              }}
                                            >
                                              <img
                                                src={src}
                                                alt=""
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                              />
                                            </li>
                                          ))}
                                          <li
                                            style={{
                                              width: "28px",
                                              height: "28px",
                                              borderRadius: "50%",
                                              background: "#D14836",
                                              color: "#fff",
                                              fontSize: "9px",
                                              fontWeight: 700,
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              marginLeft: "-10px",
                                              border: "2px solid #fff",
                                            }}
                                          >
                                            1K+
                                          </li>
                                        </ul>
                                      </div>

                                      {/* Bloc Rating */}
                                      <div>
                                        <h6
                                          style={{
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            color: "#1a1a1a",
                                            margin: "0 0 8px 0",
                                          }}
                                        >
                                          Rating
                                        </h6>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            fontWeight: 700,
                                            fontSize: "15px",
                                            color: "#0A2540",
                                          }}
                                        >
                                          4.5
                                          <span style={{ color: "#F5A623", fontSize: "16px" }}>★</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div className="sc-isRoRg hKOOCC" />
                            <div
                            data-testid="core-ui-layout-container"
                            className="sc-isRoRg hsKpoo"
                              style={{
                              transform: "translateX(130px)",
                            }}
                          >

                              {/* Texte : A propos */}
                              <div style={{ flex: "1 1 500px", minWidth: "420px" }}>
                                <p
                                  data-testid="core-ui-text"
                                  className="sc-bmzYkS sc-6e64fb35-0"
                                  style={{
                                    color: "#D14836",
                                    fontWeight: 700,
                                    fontSize: "24px",
                                    letterSpacing: "1px",
                                    textTransform: "uppercase",
                                    margin: 0,
                                  }}
                                >
                                  {t("home.about.label")}
                                </p>

                                <div data-testid="core-ui-spacer" className="sc-gsFSXq irinUj" />

                                <h2
                                  data-testid="core-ui-text"
                                  className="sc-bmzYkS dyYKrt sc-6e64fb35-0 sc-a6e6626a-0 jsXAtN"
                                  style={{
                                    color: "#0A2540",
                                    fontWeight: 800,
                                    fontSize: "34px",
                                    lineHeight: 1.25,
                                    margin: 0,
                                    textWrap: "auto",
                                  }}
                                >
                                  {t("home.about.title")}
                                </h2>

                                <div data-testid="core-ui-spacer" className="sc-gsFSXq dpVEOp" />

                                <p
                                  data-testid="core-ui-text"
                                  className="sc-bmzYkS"
                                  style={{ color: "#6B7280", lineHeight: 1.7, fontSize: "15px", textAlign: "justify", fontFamily: "'RebelSansText', sans-serif",fontWeight: 400}}
                                >
                                  {t("home.about.description")}
                                </p>

                                <div data-testid="core-ui-spacer" className="sc-gsFSXq lnyBcW" />

                                <div style={{ display: "flex", gap: "18px", flexWrap: "wrap", alignContent: "center" }}>
                                  {[
                                    { value: "stat1_value", label: "stat1_label" },
                                    { value: "stat2_value", label: "stat2_label" },
                                    { value: "stat3_value", label: "stat3_label" },
                                  ].map((stat) => (
                                    <div
                                      key={stat.value}
                                      style={{
                                        background: "#F3F5F8",
                                        borderRadius: "12px",
                                        padding: "18px 22px",
                                        textAlign: "center",
                                        maxWidth: "180px",
                                      }}
                                    >
                                      <div style={{ fontSize: "26px", fontWeight: 800, color: "#0A2540" }}>
                                        {t(`home.about.${stat.value}`)}
                                      </div>
                                      <div style={{ fontSize: "13px", color: "#6B7280", marginTop: "4px" }}>
                                        {t(`home.about.${stat.label}`)}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>

                            <div data-testid="core-ui-layout-container" className="sc-isRoRg laPHAs" />
                          </div>
                        </div>
                        <div aria-hidden="true" className="sc-d6f13c2d-1 lkohZJ" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* ── Section Rider (Ride with Metua'a + Metua'a Pink + Carousel) ── */}
              <section className="sc-b6e41a53-0 fFGzjS" data-testid="section-undefined">

                {/* Ride with Metua'a */}
                <section
                  className="sc-b6e41a53-0 kRfXnR"
                  data-tracking-action="view"
                  data-tracking-category="StylizedTextImageModule"
                  data-tracking-label="Homepage >  Brand Redesign Jun 2025 > Rider Section > Ride with Metua'a"
                  data-testid="section-undefined"
                >
                  <div data-testid="core-ui-layout-grid" className="sc-satoz eEJPJx">
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg hKOOCC" />
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg jKcZmr">
                      <div className="sc-4f1decb1-7 dcQzlr">
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq houwco" />
                        <div className="sc-4f1decb1-2 eEhuCj">
                          {/* Image desktop */}
                          <div className="sc-4f1decb1-6 jpNlBd">
                            <picture data-testid="img-container">
                              <source data-testid="webp-source" type="image/webp" srcSet={phone} />
                              <source data-testid="source" srcSet={phone} />
                              <img src={phone} alt="Metuaa screen showing route map, ride options with prices, and a highlighted Standard ride for $14.61." width={291} height={591} loading="lazy" className="sc-cb728b07-0 bLpAQa sc-3cb8a2ed-0 hZVhLw" />
                            </picture>
                          </div>
                          {/* Image mobile */}
                          <div className="sc-4f1decb1-5 dHFqgk">
                            <picture data-testid="img-container">
                              <source data-testid="webp-source" type="image/webp" srcSet="//images.ctfassets.net/q8mvene1wzq4/UJDm3PLuUpl4VlwAa2BRJ/f0ccb8f2536f46e87347530bfd123b89/Module_Hero_2_MB_FR.png?w=1500&q=60&fm=webp" />
                              <source data-testid="source" srcSet="//images.ctfassets.net/q8mvene1wzq4/UJDm3PLuUpl4VlwAa2BRJ/f0ccb8f2536f46e87347530bfd123b89/Module_Hero_2_MB_FR.png?w=1500&q=60&fm=" />
                              <img src="//images.ctfassets.net/q8mvene1wzq4/UJDm3PLuUpl4VlwAa2BRJ/f0ccb8f2536f46e87347530bfd123b89/Module_Hero_2_MB_FR.png?w=1500&q=60&fm=" alt="Metua'a app screen showing route map, ride options with prices, and a highlighted Standard ride for $14.61." width={187} height={381} loading="lazy" className="sc-cb728b07-0 bLpAQa sc-3cb8a2ed-0 hZVhLw" />
                            </picture>
                          </div>
                        </div>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq dQRMsr" />
                      </div>
                    </div>
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg lhSVzk" />
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg bIqKVe">
                      <div className="sc-4f1decb1-0 deyptR">
                        <div className="sc-4f1decb1-1 iPzTGA">
                          {/* Titres desktop & mobile */}
                          {["jpNlBd", "dHFqgk"].map((cls) => (
                            <div key={cls} className={`sc-4f1decb1-6 ${cls}`}>
                              <span data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">{t("home.rider.label")}</span>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq gnHzMj" />
                              <h2 data-testid="core-ui-text" className="sc-bmzYkS dyYKrt sc-6e64fb35-0 sc-a6e6626a-0 jsXAtN">
                                {t("home.rider.title")}
                              </h2>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" />
                            </div>
                          ))}

                          <div className="sc-f7dba9ea-2 cuxMbl">
                            <div className="sc-f7dba9ea-1 iTmZYN">
                              <p data-testid="core-ui-text" className="sc-bmzYkS bdHEFG sc-6e64fb35-0">
                                {t("home.rider.description")}
                              </p>
                            </div>
                          </div>
                          <div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" />

                          {/* Onglets feature */}
                          {[
                            { icon: <IconPickup />, iconName: "IconPickup", textId: "home.rider.feature1" },
                            { icon: <IconCalendarScheduled />, iconName: "IconCalendarScheduled", textId: "home.rider.feature2" },
                            { icon: <IconPromos />, iconName: "IconPromos", textId: "home.rider.feature3" },
                          ].map((tab) => (
                            <div key={tab.iconName} className="sc-4f1decb1-4 hiwnOg">
                              <div className="sc-dcJsrY ipvtBP">
                                <span data-testid={`icon-${tab.iconName}`} className="sc-jEACwC larDLp">
                                  {tab.icon}
                                </span>
                                <div data-testid="core-ui-spacer" className="sc-gsFSXq hefLIg" />
                                <strong data-testid="core-ui-text" className="sc-bmzYkS kfdjbm">
                                  <strong>{t(tab.textId)}</strong>
                                </strong>
                              </div>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq fuYaEf" />
                              <div className="sc-dcJsrY jSWIrf">
                                <div data-testid="core-ui-spacer" className="sc-gsFSXq lkwLmh" />
                                <div><div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" /></div>
                              </div>
                            </div>
                          ))}

                          <div data-testid="core-ui-spacer" className="sc-gsFSXq JYgNH" />

                          {/* Boutons */}
                          <div className="sc-41f9ba94-0 krZWtx">
                            <div data-testid="image-module-buttons-wrapper" className="sc-41f9ba94-1 kCgDgU">
                              <div className="sc-41f9ba94-2 dAuCwD">
                                <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                                  <a
                                    data-testid="core-ui-button"
                                    data-tracking-category="StylizedTextImageModule primary button"
                                    data-tracking-action="click"
                                    data-tracking-label="Homepage >  Brand Redesign Jun 2025 > Rider Section > Ride with Metua'a"
                                    data-tracking-value={t("home.rider.primary")}
                                    aria-disabled="false"
                                    href="https://lyft.sng.link/Adnq0/o6zi4?_dl=lyft%3A%2F%2F&_smtype=3"
                                    style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px" }}
                                    className="sc-dCFHLb sc-fhzFiK kVQIxK jPFbmJ"
                                  >
                                    <span className="sc-gmPhUn kESbtj">
                                    <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                                        <span data-testid="icon-button-text" className="sc-bmzYkS bmTkUk">{t("home.rider.primary")}</span>
                                      </span>
                                    </span>
                                  </a>
                                </span>
                                <div data-testid="core-ui-spacer" className="sc-gsFSXq coewHI" />
                              </div>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq srnOj" />
                              <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                                <a
                                  data-testid="core-ui-text-button"
                                  data-tracking-category="StylizedTextImageModule secondary button"
                                  data-tracking-action="click"
                                  data-tracking-label="Homepage >  Brand Redesign Jun 2025 > Rider Section > Ride with Metua'a"
                                  data-tracking-value={t("home.rider.secondary")}
                                  aria-disabled="false"
                                  href="https://www.lyft.com/rider"
                                  style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px" }}
                                  className="sc-dCFHLb sc-JrDLc fsCHBa cgAbXj"
                                >
                                  <span className="sc-gmPhUn kESbtj">
                                    <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                                      <span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">
                                        {t("home.rider.secondary")}
                                      </span>
                                    </span>
                                    <div data-testid="core-ui-spacer" className="sc-gsFSXq hefLIg" />
                                    <span data-testid="icon-IconArrowRight" className="sc-jEACwC fWFepk">
                                      <IconArrowRight />
                                    </span>
                                  </span>
                                </a>
                              </span>
                            </div>
                          </div>

                          <div data-testid="core-ui-spacer" className="sc-gsFSXq dMjtBb" />
                          <div className="sc-f7dba9ea-2 cuxMbl">
                            <div className="sc-f7dba9ea-1 iTmZYN">
                              <p data-testid="core-ui-text" className="sc-bmzYkS cVJtpo sc-6e64fb35-0">
                                <a href="https://www.lyft.com/memberships" title={t("home.rider.pinkLinkTitle")}>{t("home.rider.pinkLinkText")}</a>{" "}
                                {t("home.rider.membership")}
                              </p>
                            </div>
                            <div className="sc-f7dba9ea-1 iTmZYN">
                              <p data-testid="core-ui-text" className="sc-bmzYkS cVJtpo sc-6e64fb35-0">
                                {t("home.rider.termsPrefix")}{" "}
                                <a href="https://www.lyft.com/terms/memberships/lyft-pink?embeddedView=true">{t("home.rider.pinkTerms")}</a>{" "}
                                {t("home.rider.termsMiddle")} <a href="https://www.lyft.com/terms">{t("home.rider.mainTerms")}</a>.
                              </p>
                            </div>
                          </div>
                          <div data-testid="core-ui-spacer" className="sc-gsFSXq lnyBcW" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div data-testid="core-ui-spacer" className="sc-gsFSXq ibPVED" />

                <section 
                  className="servicesSection "
                  data-tracking-action="view"
                  data-tracking-category="Services"
                  data-testid="services-section"
                >
                  <div className="servicesContainer">
                    <div
                      data-testid="core-ui-layout-grid"
                      className="sc-satoz eEJPJx"
                    >
                      {/* Titre */}
                      <div
                        data-testid="core-ui-layout-container"
                        className="sc-isRoRg servicesHeading"
                      >
                        <h2
                          data-testid="core-ui-text"
                          className="servicesTitle"
                        >
                          {t("home.services.title")}
                        </h2>
                        <p
                          data-testid="core-ui-text"
                          className="servicesDescription"
                        >
                          {t("home.services.description")}
                        </p>
                      </div>
                      {/* Les cartes viendront ici */}
                      <div className="servicesCards">
                        <div className="cardCities">
                          {/* Image */}
                          <div className="cardCities-image">
                            <picture data-testid="img-container">
                              <img
                                src={course_1}
                                alt={t("home.services.course")}
                                loading="lazy"
                                className="cardCities-img"
                              />
                            </picture>
                          </div>
                          {/* Overlay */}
                          <div className="citiesCard-content">
                            <div className="cardCities-bg"></div>
                              <div className="citiesCard-middle">
                                {t("home.services.activityCount")}
                              </div>
                            {/* Partie haute (vide pour l'instant) */}
                            <div className="citiesCard-topcaps">
                            </div>
                            {/* Partie basse */}
                            <div className="citiesCard-bottomcaps">
                              <h3
                                data-testid="core-ui-text"
                                className="citiesCard-title"
                              >
                                {t("home.services.course")}
                              </h3>
                              <button
                                className="citiesCard-button"
                                type="button"
                              >
                                <span>{t("home.services.discover")}</span>
                                <span className="citiesCard-arrow">
                                  <IconArrowRight />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="cardCities">
                          {/* Image */}
                          <div className="cardCities-image">
                            <picture data-testid="img-container">
                              <img
                                src={course_2}
                                alt={t("home.services.carpooling")}
                                loading="lazy"
                                className="cardCities-img"
                              />
                            </picture>
                          </div>
                          {/* Overlay */}
                          <div className="citiesCard-content">
                            {/* Dégradé noir */}
                            <div className="cardCities-bg"></div>
                              <div className="citiesCard-middle">
                                {t("home.services.activityCount")}
                              </div>
                            {/* Partie haute (vide pour l'instant) */}
                            <div className="citiesCard-topcaps">
                            </div>
                            {/* Partie basse */}
                            <div className="citiesCard-bottomcaps">
                              <h3
                                data-testid="core-ui-text"
                                className="citiesCard-title"
                              >
                                {t("home.services.carpooling")}
                              </h3>
                              <button
                                className="citiesCard-button"
                                type="button"
                              >
                                <span>{t("home.services.discover")}</span>
                                <span className="citiesCard-arrow">
                                  <IconArrowRight />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="cardCities">
                          {/* Image */}
                          <div className="cardCities-image">
                            <picture data-testid="img-container">
                              <img
                                src={course_3}
                                alt={t("home.services.rental")}
                                loading="lazy"
                                className="cardCities-img"
                              />
                            </picture>
                          </div>
                          {/* Overlay */}
                          <div className="citiesCard-content">
                            {/* Dégradé noir */}
                            <div className="cardCities-bg"></div>
                              <div className="citiesCard-middle">
                                {t("home.services.activityCount")}
                              </div>
                            {/* Partie haute (vide pour l'instant) */}
                            <div className="citiesCard-topcaps">
                            </div>
                            {/* Partie basse */}
                            <div className="citiesCard-bottomcaps">
                              <h3
                                data-testid="core-ui-text"
                                className="citiesCard-title"
                              >
                                {t("home.services.rental")}
                              </h3>
                              <button
                                className="citiesCard-button"
                                type="button"
                              >
                                <span>{t("home.services.discover")}</span>
                                <span className="citiesCard-arrow">
                                  <IconArrowRight />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="cardCities">
                          {/* Image */}
                          <div className="cardCities-image">
                            <picture data-testid="img-container">
                              <img
                                src={course_4}
                                alt={t("home.services.delivery")}
                                loading="lazy"
                                className="cardCities-img"
                              />
                            </picture>
                          </div>
                          {/* Overlay */}
                          <div className="citiesCard-content">
                            {/* Dégradé noir */}
                            <div className="cardCities-bg"></div>
                              <div className="citiesCard-middle">
                                {t("home.services.activityCount")}
                              </div>
                            {/* Partie haute (vide pour l'instant) */}
                            <div className="citiesCard-topcaps">
                            </div>
                            {/* Partie basse */}
                            <div className="citiesCard-bottomcaps">
                              <h3
                                data-testid="core-ui-text"
                                className="citiesCard-title"
                              >
                                {t("home.services.delivery")}
                              </h3>
                              <button
                                className="citiesCard-button"
                                type="button"
                              >
                                <span>{t("home.services.discover")}</span>
                                <span className="citiesCard-arrow">
                                  <IconArrowRight />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>                  
                      </div>
                    </div>
                  </div>
                </section>

                {/* Metua'a Pink */}
                <section
                  className="sc-b6e41a53-0 kRfXnR"
                  data-tracking-action="view"
                  data-tracking-category="StylizedTextImageModule"
                  data-tracking-label="Homepage >  Brand Redesign Jun 2025 > Rider Section > Metua'a Pink"
                  data-testid="section-undefined"
                >
                  <div data-testid="core-ui-layout-grid" className="sc-satoz eEJPJx">
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg lhSVzk" />
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg eaTAFl">
                      <div className="sc-4f1decb1-7 dcQzlr">
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq houwco" />
                        <div className="sc-4f1decb1-2 eEhuCj">
                          <div className="sc-4f1decb1-6 jpNlBd">
                            <picture data-testid="img-container">
                              <source data-testid="webp-source" type="image/webp" srcSet={metuaa_green} />
                              <source data-testid="source" srcSet={metuaa_green} />
                              <img src={metuaa_green} alt="" width={1008} height={1168} loading="lazy" className="sc-cb728b07-0 bLpAQa sc-3cb8a2ed-0 hZVhLw" />
                            </picture>
                          </div>
                          <div className="sc-4f1decb1-5 dHFqgk">
                            <picture data-testid="img-container">
                              <source data-testid="webp-source" type="image/webp" srcSet={metuaa_green} />
                              <source data-testid="source" srcSet={metuaa_green} />
                              <img src={metuaa_green} alt="" width={687} height={459} loading="lazy" className="sc-cb728b07-0 bLpAQa sc-3cb8a2ed-0 hZVhLw" />
                            </picture>
                          </div>
                        </div>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq dQRMsr" />
                      </div>
                    </div>
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg hKOOCC" />
                    <div data-testid="core-ui-layout-container" className="sc-isRoRg hsKpoo">
                      <div className="sc-4f1decb1-0 deyptR">
                        <div className="sc-4f1decb1-1 wBpZU">
                          {["jpNlBd", "dHFqgk"].map((cls) => (
                            <div key={cls} className={`sc-4f1decb1-6 ${cls}`}>
                              <h2 data-testid="core-ui-text" className="sc-bmzYkS dyYKrt sc-6e64fb35-0 sc-a6e6626a-0 jsXAtN">
                                {t("home.pink.title")}
                              </h2>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" />
                            </div>
                          ))}

                          <div className="sc-f7dba9ea-2 cuxMbl">
                            <div className="sc-f7dba9ea-1 iTmZYN">
                              <p data-testid="core-ui-text" className="sc-bmzYkS bdHEFG sc-6e64fb35-0">
                                {t("home.pink.description")}
                              </p>
                            </div>
                          </div>
                          <div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" />

                          {/* Onglets Metua'a Pink */}
                          {[
                            { icon: <IconRocket />, name: "IconRocket", titleId: "home.pink.perk1.title", subId: "home.pink.perk1.sub" },
                            { icon: <IconCoupon />, name: "IconCoupon", titleId: "home.pink.perk2.title", subId: "home.pink.perk2.sub" },
                            { icon: <IconGrinningFace />, name: "IconGrinningFaceFill", titleId: "home.pink.perk3.title", subId: "home.pink.perk3.sub" },
                          ].map((tab) => (
                            <div key={tab.name} className="sc-4f1decb1-4 hiwnOg">
                              <div className="sc-dcJsrY ipvtBP">
                                <span data-testid={`icon-${tab.name}`} className="sc-jEACwC larDLp">{tab.icon}</span>
                                <div data-testid="core-ui-spacer" className="sc-gsFSXq hefLIg" />
                                <strong data-testid="core-ui-text" className="sc-bmzYkS kfdjbm">
                                  <strong>{t(tab.titleId)}</strong>
                                </strong>
                              </div>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq fuYaEf" />
                              <div className="sc-dcJsrY jSWIrf">
                                <div data-testid="core-ui-spacer" className="sc-gsFSXq lkwLmh" />
                                <div>
                                  <div className="sc-f7dba9ea-2 cuxMbl">
                                    <div className="sc-f7dba9ea-1 iTmZYN">
                                      <p data-testid="core-ui-text" className="sc-bmzYkS bdHEFG sc-6e64fb35-0">{t(tab.subId)}</p>
                                    </div>
                                  </div>
                                  <div data-testid="core-ui-spacer" className="sc-gsFSXq fORnup" />
                                </div>
                              </div>
                            </div>
                          ))}

                          <div data-testid="core-ui-spacer" className="sc-gsFSXq JYgNH" />
                          <div className="sc-41f9ba94-0 krZWtx">
                            <div data-testid="image-module-buttons-wrapper" className="sc-41f9ba94-1 kCgDgU">
                              <div className="sc-41f9ba94-2 dAuCwD">
                                <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                                  <a
                                    data-testid="core-ui-button"
                                    data-tracking-category="StylizedTextImageModule primary button"
                                    data-tracking-action="click"
                                    data-tracking-label="Homepage >  Brand Redesign Jun 2025 > Rider Section > Metua'a Pink"
                                    data-tracking-value={t("home.pink.primary")}
                                    aria-disabled="false"
                                    href="https://www.lyft.com/memberships/lyft-pink-all-access-annual/offer-details"
                                    style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px" }}
                                    className="sc-dCFHLb sc-fhzFiK kVQIxK jPFbmJ"
                                  >
                                    <span className="sc-gmPhUn kESbtj">
                                      <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                                        <span data-testid="icon-button-text" className="sc-bmzYkS bmTkUk">{t("home.pink.primary")}</span>
                                      </span>
                                    </span>
                                  </a>
                                </span>
                                <div data-testid="core-ui-spacer" className="sc-gsFSXq coewHI" />
                                <div data-testid="core-ui-spacer" className="sc-gsFSXq JPSGo" />
                                <div className="sc-f7dba9ea-2 cuxMbl">
                                  <div className="sc-f7dba9ea-1 iTmZYN">
                                <p data-testid="core-ui-text" className="sc-bmzYkS cVJtpo sc-6e64fb35-0">
                                      {t("home.pink.termsPrefix")}{" "}
                                      <a href="https://www.lyft.com/terms/memberships/lyft-pink?embeddedView=true">{t("home.rider.pinkTerms")}</a>{" "}
                                      {t("home.pink.termsMiddle")} <a href="https://www.lyft.com/terms">{t("home.rider.mainTerms")}</a>.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div data-testid="core-ui-spacer" className="sc-gsFSXq dMjtBb" />
                          <div className="sc-f7dba9ea-2 cuxMbl">
                            <div className="sc-f7dba9ea-1 iTmZYN">
                              <p data-testid="core-ui-text" className="sc-bmzYkS cVJtpo sc-6e64fb35-0">
                                {t("home.pink.termsPrefix")}{" "}
                                <a href="https://www.lyft.com/terms/memberships/lyft-pink?embeddedView=true">{t("home.rider.pinkTerms")}</a>{" "}
                                {t("home.pink.termsMiddle")} <a href="https://www.lyft.com/terms">{t("home.rider.mainTerms")}</a>.
                              </p>
                            </div>
                          </div>
                          <div data-testid="core-ui-spacer" className="sc-gsFSXq lnyBcW" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div data-testid="core-ui-spacer" className="sc-gsFSXq ibPVED" />

                {/* ── Carrousel des modes ── */}
                <section
                  className="sc-b6e41a53-0 kRfXnR"
                  data-tracking-action="view"
                  data-tracking-category="InfoCardCarousel"
                  data-tracking-label="Homepage > Brand Redesign Sep 2025 > Default Mode Carousel"
                  data-testid="section-undefined"
                >
                  <div className="sc-1b0948ad-9 kkQdzk">
                    <div className="sc-satoz eEJPJx sc-7f683142-0 ivWiRm">
                      <div data-testid="core-ui-layout-container" className="sc-isRoRg efilsy" />
                      <div data-testid="core-ui-layout-container" className="sc-isRoRg bGsZqN">
                        <div role="group" aria-roledescription="carousel" aria-label="Slides">
                          {/* En-tête + boutons navigation */}
                          <div className="sc-1b0948ad-6 wXIBv">
                            <div className="sc-1b0948ad-7 gMStWA">
                              <h2 data-testid="core-ui-text" className="sc-bmzYkS dyYKrt sc-6e64fb35-0 sc-a6e6626a-0 jsXAtN">
                                {t("home.carousel.title")}
                              </h2>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq ccZdps" />
                              <div className="sc-f7dba9ea-2 cuxMbl">
                                <div className="sc-f7dba9ea-1 iTmZYN">
                                  <p data-testid="core-ui-text" className="sc-bmzYkS futovn sc-6e64fb35-0">
                                    {t("home.carousel.description")}
                                  </p>
                                </div>
                              </div>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq gYaECH" />
                            </div>
                            <div className="sc-1b0948ad-4 gMLmHG">
                              {/* Bouton précédent */}
                              <div className="sc-1b0948ad-5 cYZXCS">
                                <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                                  <button
                                    data-testid="core-ui-icon-button"
                                    aria-label={t("home.carousel.prev")}
                                    type="button"
                                    aria-disabled={carouselOffset === 0}
                                    onClick={() => setCarouselOffset((prev) => Math.max(0, prev - cardWidth))}
                                    style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px", "--height": "48px", "--width": "48px" }}
                                    className={`sc-dCFHLb sc-hknOHE ${carouselOffset === 0 ? "dGxLBB Lanqo" : "kVYxaI"}`}
                                  >
                                    <span className="sc-gmPhUn kESbtj">
                                      <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                                        <IconArrowLeft />
                                      </span>
                                    </span>
                                  </button>
                                </span>
                              </div>
                              {/* Bouton suivant */}
                              <div className="sc-1b0948ad-5 cYZXCS">
                                <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                                  <button
                                    data-testid="core-ui-circular-button"
                                    aria-label={t("home.carousel.next")}
                                    type="button"
                                    aria-disabled={carouselOffset >= maxOffset}
                                    onClick={() => setCarouselOffset((prev) => Math.min(maxOffset, prev + cardWidth))}
                                    style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px", "--height": "48px", "--width": "48px" }}
                                    className={`sc-dCFHLb sc-fhzFiK kVYxaI ${carouselOffset >= maxOffset ? "dGxLBB" : "jPFbmJ"}`}
                                  >
                                    <span className="sc-gmPhUn kESbtj">
                                      <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
                                        <IconArrowRightLg />
                                      </span>
                                    </span>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Piste du carrousel */}
                          <div tabIndex={0} className="sc-1b0948ad-0 Baer">
                            <div
                              className="sc-1b0948ad-1 iHgPNY"
                              style={{ overflow: "hidden", width: "100%" }}
                            >
                              <div
                                style={{
                                  transform: `translate(${-carouselOffset}px)`,
                                  display: "flex",
                                  gap: "8px",
                                  transition: "transform 350ms cubic-bezier(0.45, 0, 0.15, 1)",
                                  willChange: "transform",
                                }}
                                className="sc-1b0948ad-2 gOTUDz"
                              >
                                {carouselCards.map((card, i) => (
                                  <CarouselCard key={i} card={card} index={i} />
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Note légale */}
                          <div className="sc-1b0948ad-8 dZfNJM">
                            <div className="sc-f7dba9ea-2 cuxMbl">
                              <ul>
                                <li>{t("home.carousel.note")}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </section>

              {/* ── Metua'a Business ── */}
              <section
                className="sc-cd975d71-0 cNVcPq sc-4d039203-0 eelzdD"
                data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Business"
                data-tracking-action="view"
                data-tracking-category="TextImageModule"
              >
                <div className="sc-eNSrOW kusvag">
                  <div data-testid="core-ui-layout-grid" className="sc-satoz iOqNLX">
                    <div className="sc-cd975d71-0 hWnSlW">
                      <div className="sc-d6f13c2d-0 gLYlJz">
                        <div aria-hidden="true" className="sc-d6f13c2d-1 lkohZJ" />
                        <div className="sc-d6f13c2d-2 cGKmAe">
                          <div data-testid="core-ui-layout-grid" className="sc-satoz iYojpr">
                            <div data-testid="core-ui-layout-container" className="sc-isRoRg ivgUiU" />
                            <div data-testid="core-ui-layout-container" className="sc-isRoRg hsKpoo">
                              <div className="sc-1f8fcd9f-2 dhVyTx">
                                <picture data-testid="img-container">
                                  <source data-testid="webp-source" type="image/webp" srcSet="//images.ctfassets.net/q8mvene1wzq4/1K1rAz1oWBVVk9RtJFDSxf/fc0b833665df98224c9722c6cfe652a3/Module_Hero_4_DT.png?w=1500&q=60&fm=webp" />
                                  <source data-testid="source" srcSet="//images.ctfassets.net/q8mvene1wzq4/1K1rAz1oWBVVk9RtJFDSxf/fc0b833665df98224c9722c6cfe652a3/Module_Hero_4_DT.png?w=1500&q=60&fm=" />
                                  <img src="//images.ctfassets.net/q8mvene1wzq4/1K1rAz1oWBVVk9RtJFDSxf/fc0b833665df98224c9722c6cfe652a3/Module_Hero_4_DT.png?w=1500&q=60&fm=" alt="Woman in white top and maroon coat stands outside house, holding a bag, seen through a car window with driver inside." width={1008} height={672} loading="lazy" className="sc-cb728b07-0 bLpAQa sc-3cb8a2ed-0 hZVhLw" />
                                </picture>
                              </div>
                            </div>
                            <div data-testid="core-ui-layout-container" className="sc-isRoRg ckYcK" />
                            <div data-testid="core-ui-layout-container" className="sc-isRoRg eaTAFl">
                              <div className="sc-1f8fcd9f-0 gGAUly">
                                <div className="sc-1f8fcd9f-1 jvlpyP">
                                  <h2 data-testid="core-ui-text" className="sc-bmzYkS dyYKrt sc-6e64fb35-0 sc-a6e6626a-0 jsXAtN">
                                    {t("home.business.title")}
                                  </h2>
                                  <div data-testid="core-ui-spacer" className="sc-gsFSXq dpVEOp" />
                                  <div className="sc-f7dba9ea-2 cuxMbl">
                                    <div className="sc-f7dba9ea-1 iTmZYN">
                                      <p data-testid="core-ui-text" className="sc-bmzYkS bdHEFG sc-6e64fb35-0">
                                        {t("home.business.description")}
                                      </p>
                                    </div>
                                  </div>
                                  <div data-testid="core-ui-spacer" className="sc-gsFSXq lnyBcW" />
                                  <div className="sc-1f8fcd9f-6 jgZIuX">
                                    <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                                      <a data-testid="core-ui-button" data-tracking-action="click" data-tracking-category="TextImageModule primary button" data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Business" data-tracking-value={t("home.business.primary")} className="sc-dCFHLb sc-fhzFiK kVQIxK jPFbmJ sc-702c0626-0 zZFYV" aria-disabled="false" href="/business" style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px" }}>
                                        <span className="sc-gmPhUn kESbtj"><span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn"><span data-testid="icon-button-text" className="sc-bmzYkS bmTkUk">{t("home.business.primary")}</span></span></span>
                                      </a>
                                    </span>
                                    <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                                      <a data-testid="core-ui-text-button" data-tracking-action="click" data-tracking-category="TextImageModule secondary button" data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Business" data-tracking-value={t("home.business.secondary")} aria-disabled="false" href="/business/solutions" style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px" }} className="sc-dCFHLb sc-JrDLc fsCHBa cgAbXj">
                                        <span className="sc-gmPhUn kESbtj"><span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn"><span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">{t("home.business.secondary")}</span></span><div data-testid="core-ui-spacer" className="sc-gsFSXq hefLIg" /><span data-testid="icon-IconArrowRight" className="sc-jEACwC fWFepk"><IconArrowRight /></span></span>
                                      </a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div data-testid="core-ui-spacer" className="sc-gsFSXq dQRMsr" />
                            </div>
                            <div data-testid="core-ui-layout-container" className="sc-isRoRg laPHAs" />
                          </div>
                        </div>
                        <div aria-hidden="true" className="sc-d6f13c2d-1 lkohZJ" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* ── Sécurité ── */}
<section
  className="sc-cd975d71-0 fJfYVy sc-4d039203-0 iaLMvL"
  data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Up"
  data-tracking-action="view"
  data-tracking-category="TextImageModule"
>
  <div className="sc-eNSrOW kusvag">
    <div data-testid="core-ui-layout-grid" className="sc-satoz iOqNLX">
      <div className="sc-cd975d71-0 hWnSlW">
        <div className="sc-d6f13c2d-0 gLYlJz">
          <div aria-hidden="true" className="sc-d6f13c2d-1 lkohZJ" />
          <div className="sc-d6f13c2d-2 cGKmAe">
            <div data-testid="core-ui-layout-grid" className="sc-satoz iYojpr">
              <div data-testid="core-ui-layout-container" className="sc-isRoRg ivgUiU" />

              {/* Colonne 1 : Card Package Famille (remplace l'image seule) */}
              
              <div data-testid="core-ui-layout-container" className="sc-isRoRg bNKeFk">
                <div
                  className="cardOffer"
                  style={{ backgroundImage: `url(${offer_1})` }}
                >
                  <div className="cardOffer-overlay">
                    <p className="cardOffer-label">
                      {t("home.offers.family.label")}
                    </p>

                    <h3 className="cardOffer-title">
                      {t("home.offers.family.title")}
                    </h3>

                    <div className="cardOffer-code">
                      <span className="cardOffer-code-label">
                        {t("home.offers.codeLabel")}
                      </span>

                      <span className="cardOffer-code-value">
                        {t("home.offers.codeValue")}
                      </span>
                    </div>

                    <button className="cardOffer-button">
                      {t("home.offers.discover")}
                      <IconArrowRight />
                    </button>
                  </div>
                </div>
                <div data-testid="core-ui-spacer" className="sc-gsFSXq dQRMsr" />
              </div>

              {/* Colonne 2 : Card Package Entreprise (remplace le texte) */}
              <div data-testid="core-ui-layout-container" className="sc-isRoRg elvggF">
                <div
                  className="cardOffer"
                  style={{ backgroundImage: `url(${offer_2})` }}
                >
                  <div className="cardOffer-overlay">
                    <p className="cardOffer-label">
                      {t("home.offers.business.label")}
                    </p>

                    <h3 className="cardOffer-title">
                      {t("home.offers.business.title")}
                    </h3>

                    <div className="cardOffer-code">
                      <span className="cardOffer-code-label">
                        {t("home.offers.codeLabel")}
                      </span>

                      <span className="cardOffer-code-value">
                        {t("home.offers.codeValue")}
                      </span>
                    </div>

                    <button
                      type="button"
                      className="cardOffer-button"
                    >
                      <span>{t("home.offers.discover")}</span>
                      <IconArrowRight />
                    </button>
                  </div>
                </div>
              </div>

              <div data-testid="core-ui-layout-container" className="sc-isRoRg laPHAs" />
            </div>
          </div>
          <div aria-hidden="true" className="sc-d6f13c2d-1 lkohZJ" />
        </div>
      </div>
    </div>
  </div>
</section>


              {/* ── Téléchargement des applis ── */}
              <section
                className="sc-b6e41a53-0 bZuzVD"
                data-tracking-action="view"
                data-tracking-category="TwoColumnModule"
                data-tracking-label="Homepage > Brand Redesign Jun 2025 > App Downloads > Desktop"
                data-testid="section-undefined"
              >
                <div data-testid="core-ui-spacer" className="sc-gsFSXq gDqWRX" />
                <div className="sc-satoz eEJPJx sc-7f683142-0 ivWiRm">
                  <div data-testid="core-ui-layout-container" className="sc-isRoRg efilsy" />
                  <div data-testid="core-ui-layout-container" className="sc-isRoRg bGsZqN">
                    <div className="sc-3a4d0649-1">
                      <h2 data-testid="core-ui-text" className="sc-bmzYkS dyYKrt sc-6e64fb35-0 sc-a6e6626a-0 jsXAtN">
                        {t("home.downloads.title")}
                      </h2>
                    </div>
                  </div>
                </div>
                <div data-testid="core-ui-spacer" className="sc-gsFSXq dpVEOp" />
                <div data-testid="core-ui-spacer" className="sc-gsFSXq dUpILl" />
                <div data-testid="core-ui-layout-grid" className="sc-satoz eEJPJx">
                  <div data-testid="core-ui-layout-container" className="sc-isRoRg efilsy" />

                  {/* QR Passager */}
                  <div data-testid="core-ui-layout-container" className="sc-isRoRg bmuErw">
                    <div data-testid="Two-Column-Entry" className="sc-c53dbb0f-0 iOhLbs">
                      <a href="https://lyft.sng.link/Adnq0/o6zi4?_dl=lyft%3A%2F%2F&_smtype=3">
                        <picture data-testid="img-container">
                          <source data-testid="webp-source" type="image/webp" srcSet={app1} />
                          <source data-testid="source" srcSet={app1} />
                          <img src={app1} alt="A black and white QR code with a pink Metua'a logo in the center." height={400} width={800} loading="lazy" className="sc-cb728b07-0 bLpAQa sc-c53dbb0f-1 gsvfdX" />
                        </picture>
                      </a>
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq jcXASy" />
                      <div className="sc-c53dbb0f-4 bmbrGS">
                        <div className="sc-f7dba9ea-2 eHckoN sc-c53dbb0f-2 eZNRmC">
                          <div className="sc-f7dba9ea-1 iTmZYN">
                            <p data-testid="core-ui-text" className="sc-bmzYkS bdHEFG sc-6e64fb35-0">{t("home.downloads.scan")}</p>
                          </div>
                        </div>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq lnyBcW" />
                        <div className="sc-c53dbb0f-3 jXmeFW">
                          <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                            <a data-testid="core-ui-text-button" data-tracking-category="TwoColumnEntry primary button" data-tracking-action="click" data-tracking-label="Homepage > Brand Redesign Jun 2025 > App Download Pre-footer > Rider App" data-tracking-value={t("home.downloads.rider")} aria-disabled="false" href="https://lyft.sng.link/Adnq0/o6zi4?_dl=lyft%3A%2F%2F&_smtype=3" style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px" }} className="sc-dCFHLb sc-JrDLc sc-fjvvzt fsCHBa cgAbXj kMrRzy">
                              <span className="sc-gmPhUn kESbtj"><span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn"><span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">{t("home.downloads.rider")}</span></span><div data-testid="core-ui-spacer" className="sc-gsFSXq hefLIg" /><span data-testid="icon-IconArrowRight" className="sc-jEACwC fWFepk"><IconArrowRight /></span></span>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div data-testid="core-ui-spacer" className="sc-gsFSXq kDLjAb" />
                  </div>

                  <div data-testid="core-ui-layout-container" className="sc-isRoRg efilsy" />

                  {/* QR Chauffeur */}
                  <div data-testid="core-ui-layout-container" className="sc-isRoRg bmuErw">
                    <div data-testid="Two-Column-Entry" className="sc-c53dbb0f-0 iOhLbs">
                      <a href="https://lyftdriver.sng.link/Alqxq/8lflu?_dl=lyftdriver%3A%2F%2Fhome&_smtype=3">
                        <picture data-testid="img-container">
                          <source data-testid="webp-source" type="image/webp" srcSet={app2} />
                          <source data-testid="source" srcSet={app2} />
                          <img src={app2} alt="" height={600} width={1200} loading="lazy" className="sc-cb728b07-0 bLpAQa sc-c53dbb0f-1 gsvfdX" />
                        </picture>
                      </a>
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq jcXASy" />
                      <div className="sc-c53dbb0f-4 bmbrGS">
                        <div className="sc-f7dba9ea-2 eHckoN sc-c53dbb0f-2 eZNRmC">
                          <div className="sc-f7dba9ea-1 iTmZYN">
                            <p data-testid="core-ui-text" className="sc-bmzYkS bdHEFG sc-6e64fb35-0">{t("home.downloads.scan")}</p>
                          </div>
                        </div>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq lnyBcW" />
                        <div className="sc-c53dbb0f-3 jXmeFW">
                          <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                            <a data-testid="core-ui-text-button" data-tracking-category="TwoColumnEntry primary button" data-tracking-action="click" data-tracking-label="Homepage > Brand Redesign Jun 2025 > App Downloads > Desktop > Driver App" data-tracking-value={t("home.downloads.driver")} aria-disabled="false" href="https://lyftdriver.sng.link/Alqxq/acl6?_dl=lyftdriver%3A%2F%2Fhome&_smtype=3" style={{ "--padding": "24px", "--min-height": "48px", "--min-width": "120px" }} className="sc-dCFHLb sc-JrDLc sc-fjvvzt fsCHBa cgAbXj kMrRzy">
                              <span className="sc-gmPhUn kESbtj"><span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn"><span data-testid="icon-button-text" className="sc-bmzYkS cLfdwp">{t("home.downloads.driver")}</span></span><div data-testid="core-ui-spacer" className="sc-gsFSXq hefLIg" /><span data-testid="icon-IconArrowRight" className="sc-jEACwC fWFepk"><IconArrowRight /></span></span>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-testid="core-ui-spacer" className="sc-gsFSXq gDqWRX" />
              </section>
            </main>

            {/* ══════════════════ FOOTER ══════════════════ */}
            <Footer />
          </span>
        </span>
      </div>
    </div>
  );
}
